import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/helpers";
import { Star } from "lucide-react";
type CourseRatingStarsProps = {
  count: number;
  colorVariant: "gray" | "lime" | "orange";
  starSize?: number;
  className?: string;
};
export default function RatingStars(t0) {
  const $ = _c(22);
  const {
    count,
    colorVariant,
    starSize: t1,
    className
  } = t0;
  const starSize = t1 === undefined ? 18 : t1;
  const fullStars = Math.floor(count);
  const hasHalfStar = count % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex items-center gap-1", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== fullStars) {
    t3 = [...Array(fullStars)];
    $[2] = fullStars;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== colorVariant || $[5] !== starSize || $[6] !== t3) {
    t4 = t3.map((_, i) => <Star key={`full-${i}`} size={starSize} className={colorVariant === "gray" ? "fill-foreground stroke-foreground opacity-90" : colorVariant === "lime" ? "fill-landingPagePrimary stroke-landingPagePrimary" : colorVariant === "orange" ? "fill-reviewStar stroke-reviewStar" : ""} />);
    $[4] = colorVariant;
    $[5] = starSize;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== colorVariant || $[9] !== hasHalfStar || $[10] !== starSize) {
    t5 = hasHalfStar && <div className="relative" style={{
      height: `${starSize}px`,
      width: `${starSize}px`
    }}><Star size={starSize} className="absolute fill-gray-300 stroke-gray-300 dark:fill-gray-600 dark:stroke-gray-600" /><Star size={starSize} className={cn("absolute", colorVariant === "gray" ? "fill-foreground stroke-foreground opacity-90" : colorVariant === "lime" ? "fill-landingPagePrimary stroke-landingPagePrimary" : colorVariant === "orange" ? "fill-reviewStar stroke-reviewStar" : "")} style={{
        clipPath: "inset(0 50% 0 0)"
      }} /></div>;
    $[8] = colorVariant;
    $[9] = hasHalfStar;
    $[10] = starSize;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== emptyStars) {
    t6 = [...Array(emptyStars)];
    $[12] = emptyStars;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== starSize || $[15] !== t6) {
    t7 = t6.map((__0, i_0) => <Star key={`empty-${i_0}`} size={starSize} className="fill-gray-300 stroke-gray-300 dark:fill-gray-600 dark:stroke-gray-600" />);
    $[14] = starSize;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t2 || $[18] !== t4 || $[19] !== t5 || $[20] !== t7) {
    t8 = <div className={t2}>{t4}{t5}{t7}</div>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}